module.exports = __webpack_public_path__ + "img/94b73ba445a960926339d17adec657c8.94b73ba4.png";